module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grid",
    attrs: {
      "id": "scoring-manage"
    }
  }, [_c('table', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('tr', {
    staticClass: "grid"
  }, [_c('button', {
    staticClass: "col-12",
    on: {
      "click": _vm.updateScores
    }
  }, [_vm._v("Update Scores")])]), _vm._v(" "), _c('tr', {
    staticClass: "grid"
  }, [_c('td', {
    staticClass: "col-2"
  }, [_vm._v("\n      Status\n    ")]), _vm._v(" "), _c('td', {
    staticClass: "col"
  }, [_vm._v("\n      " + _vm._s(_vm.status) + "\n    ")])]), _vm._v(" "), _c('tr', {
    staticClass: "grid"
  }, [_c('td', {
    staticClass: "col-2"
  }, [_vm._v("\n      Collection\n    ")]), _vm._v(" "), _c('td', {
    staticClass: "col"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proset),
      expression: "proset"
    }],
    attrs: {
      "type": "text",
      "placeholder": "e.g., Algo_22a"
    },
    domProps: {
      "value": (_vm.proset)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.proset = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', {
    staticClass: "grid"
  }, [_c('td', {
    staticClass: "col-2"
  }, [_vm._v("\n      Normal Problems\n    ")]), _vm._v(" "), _c('td', {
    staticClass: "col"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.normal_problems),
      expression: "normal_problems"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Space-separated challenge IDs"
    },
    domProps: {
      "value": (_vm.normal_problems)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.normal_problems = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', {
    staticClass: "grid"
  }, [_c('td', {
    staticClass: "col-2"
  }, [_vm._v("\n      Bonus Problems\n    ")]), _vm._v(" "), _c('td', {
    staticClass: "col"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bonus_problems),
      expression: "bonus_problems"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Space-separated challenge IDs"
    },
    domProps: {
      "value": (_vm.bonus_problems)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bonus_problems = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', {
    staticClass: "grid"
  }, [_c('button', {
    staticClass: "col-12",
    on: {
      "click": _vm.computeScores
    }
  }, [_vm._v("Compute Scores")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.score_sums),
      expression: "score_sums"
    }],
    staticClass: "col-12",
    attrs: {
      "rows": "3"
    },
    domProps: {
      "value": (_vm.score_sums)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.score_sums = $event.target.value
      }
    }
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.results),
      expression: "results"
    }],
    staticClass: "col-12",
    attrs: {
      "placeholder": "Results will be shown here",
      "rows": "50"
    },
    domProps: {
      "value": (_vm.results)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.results = $event.target.value
      }
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "grid"
  }, [_c('th', {
    staticClass: "col-2"
  }), _vm._v(" "), _c('th', {
    staticClass: "col"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a75daa96"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ScoringManage.vue
// module id = 591
// module chunks = 0